import {createFetchableSlice} from '../../../utils/createFetchableSlice';
import {fetchSchedules} from '../../../Api';

export const schedulesSlice = createFetchableSlice({
    name: 'schedules',
    fetchable: fetchSchedules
});

export default schedulesSlice.reducer;
